import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './Disciplines.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import Loader from 'components/UI/Loader/Loader'
import AddDisciplineModal from './AddDisciplineModal/AddDisciplineModal'
import RowDiscipline from './RowDiscipline/RowDiscipline'

const initPagination = {
  page: 1,
  limit: 10,
}

const Disciplines = () => {
  const [disciplines, setDisciplines] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const fetchSkills = () => {
    superAxiosRequest({
      method: 'get',
      link: 'db/disciplines',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setDisciplines(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchSkills()
  }, [pagination])

  const onBeforeSubmitClient = (data) => {
    const { name, company, ...rest } = data
    return {
      ...rest,
      ...(name && { name: data.name }),
      ...(company && { company: data?.company?.id }),
    }
  }

  const addDiscipline = () => {
    const ms = {
      modalBodyComponent: () => <AddDisciplineModal />,
      button: 'Save',
      link: 'db/disciplines',
      title: 'Add discipline (language)',
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchSkills()
      },
      valid: {
        name: 'required',
      },
    }

    asideModalStore.activity(ms, {})
  }

  const editDiscipline = (data) => {
    const ms = {
      modalBodyComponent: () => <AddDisciplineModal />,
      button: 'Save',
      link: `db/disciplines/${data?.id}`,
      title: 'Edit discipline',
      isResponsive: true,
      is_put: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setDisciplines((prev) => {
          return {
            ...prev,
            result: prev.result.map((program) =>
              program.id === data.id ? { ...program, ...data } : program,
            ),
          }
        })
      },
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteDiscipline = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the discipline?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `db/disciplines/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setDisciplines((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editDiscipline(items)],
      ['delete', () => deleteDiscipline(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={'Disciplines'}>
          <HeaderAddButton title={'Add discipline'} onClick={addDiscipline} />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            Records: {disciplines?._meta?.count_items}
          </div>
          <div>
            {disciplines?.result?.map((level, index) => (
              <RowDiscipline
                key={level.id}
                level={level}
                index={index}
                action={action}
              />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {disciplines?._meta.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={disciplines._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default Disciplines
